/**
 * Format a number with commas for thousands separators
 * @param num - Number to format
 * @returns Formatted number string
 */
const formatNumber = (num: number): string => {
  return num.toLocaleString();
};

/**
 * Format a number as currency in pounds sterling
 * @param amount - Amount to format
 * @returns Formatted currency string
 */
const formatCurrency = (amount: number): string => {
  return amount.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Format a balance for display
 * @param balance - Balance to format
 * @returns Formatted balance string
 */
const getBalanceDisplay = (balance: number) => {
  return formatNumber(balance);
};

export default formatNumber;
export { formatCurrency, getBalanceDisplay };
